import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Button, Container, Input, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import ChatBot from './ChatBot';

const Chat = () => {


    return (
        <React.Fragment>
            <div className='page-content'>
                        <BreadCrumb title="Chat Bot"/>
                                    <ChatBot />
            </div>
        </React.Fragment>
    );
};

export default Chat;
